import { UserDto } from 'booksprout'

/**
 * Normalises a raw user payload from the API: trims the name and revives the date fields, which
 * arrive as strings.
 *
 * Extracted from UserService because it is a pure transform and AuthService needed it too — that
 * was the only reason AuthService depended on UserService, and moving it here lets
 * authenticationService stand alone. UserService still exposes it (its interface member is
 * injected in 24 places) by delegating here.
 */
export const makeUserResult = (user: any): UserDto => {
  return {
    ...user,
    // A name never set arrives as null and has to stay null: a field reads undefined as "not loaded yet" and
    // adopts the first value it sees, so a whole name pasted into the empty box looked unchanged and was never
    // saved. The null contract is sc-28796's. [sc-29284]
    name: typeof user.name === 'string' ? user.name.trim() : user.name,
    termsConsentDate: user.termsConsentDate
      ? new Date(user.termsConsentDate)
      : void 0,
    termsConsentRevokedDate: user.termsConsentRevokedDate
      ? new Date(user.termsConsentRevokedDate)
      : void 0,
    topReviewerAppStatusDate: user.topReviewerAppStatusDate
      ? new Date(user.topReviewerAppStatusDate)
      : void 0
  }
}
